import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { SkeletonModule } from 'primeng/skeleton';
import { ModalWrapperComponent } from './modal-wrapper.component';

/**
 * Kept separate from SharedModule on purpose: SharedModule declares VoucherListComponent,
 * which imports TextAreaModalComponent, which needs app-modal-wrapper — importing SharedModule
 * itself from TextAreaModalComponent created a circular module dependency (text-area-modal ->
 * shared.module -> voucher-list -> text-area-modal), leaving TextAreaModalComponent `undefined`
 * at the moment DialogService tried to instantiate it (Angular error: "Cannot read properties
 * of undefined (reading 'ɵcmp')"). This module has no such back-reference.
 */
@NgModule({
  declarations: [ModalWrapperComponent],
  imports: [CommonModule, ButtonModule, TooltipModule, SkeletonModule],
  exports: [ModalWrapperComponent],
})
export class ModalWrapperModule {}
